(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[55013],{

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35533);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39717);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);







function FeatureList({ featureList , mainTitle , mainDescription , colors , classes  }) {
    const outerSectionStyle = {
        "--bg": `${colors?.bgColor ?? "transparent"}`,
        "--iconColor": `${colors?.iconColor ?? "gray"}`
    };
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: outerSectionStyle,
        className: `mt-10 lg:mt-16 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mainSection)} `,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes?.mainSectionClasses ?? "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        color: colors?.mainTitleColor ?? "black"
                    },
                    className: classes?.mainTitleClasses ?? "text-center text-xl lg:text-2xl mb-14",
                    children: mainTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        color: colors?.mainDescriptionColor ?? "black"
                    },
                    className: classes?.mainDescriptionClasses ?? "",
                    children: mainDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes?.innerSectionClasses ?? "lg:flex flex-wrap justify-center",
                    children: featureList?.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classes?.oneBoxClasses ? `${classes?.oneBoxClasses} ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""}` : `text-center mb-12 lg:mb-20 w-full lg:w-1/3   ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""} `,
                            children: [
                                item.path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes?.iconClasses ?? "relative mb-14 w-[190px] h-[190px]  mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.path,
                                        layout: "fill",
                                        alt: item.title
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes?.iconClasses ?? "children:w-12 children:h-12 children:mx-auto ",
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    style: {
                                        color: colors?.titleColor ?? "black"
                                    },
                                    className: classes?.titleClasses ?? "font-medium text-lg lg:text-xl mt-6",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        color: colors?.descriptionColor ?? "black"
                                    },
                                    className: classes?.descriptionClasses ?? "font-light text-sm text-center w-4/5 mx-auto mt-2",
                                    children: item.description
                                }),
                                item.tool && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: `/tools/${item.tool}?${(0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start")}`,
                                    className: classes?.toolClasses ? `${classes?.toolClasses} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}` : `mt-4 flex gap-2 items-center md:mt-auto ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}`,
                                    style: {
                                        color: colors?.toolColor ?? "black"
                                    },
                                    children: [
                                        "Details",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "transform rotate-180",
                                            fill: colors?.chevronColor
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chevron; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Chevron({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z",
            fill: fill ?? "black"
        })
    });
}


/***/ }),

/***/ 55013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WhyUs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/topcommercialcleaners/icons/clock.tsx


function Clock() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "80",
        height: "80",
        fill: "none",
        viewBox: "0 0 80 80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_1_53",
                style: {
                    maskType: "alpha"
                },
                width: "80",
                height: "80",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H80V80H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_1_53)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#FF8A00",
                    d: "M40 70c-16.543 0-30-13.457-30-30s13.457-30 30-30a2.5 2.5 0 010 5c-13.785 0-25 11.214-25 25 0 13.784 11.215 24.999 25 24.999s25-11.215 25-25a2.5 2.5 0 115 0c0 16.543-13.458 30-30 30V70zm0-55c-.65 0-1.3-.275-1.775-.725a2.63 2.63 0 01-.725-1.774c0-.65.275-1.3.725-1.775.95-.925 2.625-.925 3.55 0A2.63 2.63 0 0142.5 12.5c0 .65-.275 1.3-.725 1.775A2.63 2.63 0 0140 15zm23.1 15.425c-.525-1.275.072-2.75 1.35-3.275 1.275-.525 2.75.075 3.275 1.35.525 1.275-.075 2.75-1.35 3.275-.325.125-.65.2-.95.2-1 0-1.927-.575-2.325-1.55zm-5.427-8.1a2.52 2.52 0 010-3.55 2.49 2.49 0 013.524 0 2.515 2.515 0 010 3.55 2.492 2.492 0 01-1.747.724c-.65 0-1.275-.25-1.777-.725zM49.575 16.9c-1.277-.525-1.875-2-1.35-3.275.525-1.275 1.975-1.876 3.275-1.35 1.275.524 1.875 2 1.325 3.274-.375.95-1.325 1.525-2.3 1.525-.325 0-.65-.05-.95-.175zM67.5 42.5c-.65 0-1.302-.276-1.775-.726A2.617 2.617 0 0165 40c0-.65.273-1.3.725-1.775.95-.925 2.625-.925 3.55 0A2.63 2.63 0 0170 40c0 .65-.275 1.3-.725 1.775a2.63 2.63 0 01-1.775.725zm-17.503 5c-.375 0-.757-.086-1.115-.263l-10-5a2.502 2.502 0 01-1.382-2.238V22.5a2.5 2.5 0 015 0v15.955l8.617 4.31a2.5 2.5 0 01-1.12 4.735z"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/topcommercialcleaners/icons/circles.tsx


function Circles() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "80",
        height: "80",
        fill: "none",
        viewBox: "0 0 80 80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_5_117",
                style: {
                    maskType: "alpha"
                },
                width: "80",
                height: "80",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H80V80H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#FF8A00",
                mask: "url(#mask0_5_117)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M62.4 25.708a7.352 7.352 0 01-7.354-7.354 7.354 7.354 0 117.354 7.354zm0-11.03a3.766 3.766 0 10-.001 7.53 3.766 3.766 0 000-7.53zM11.639 40.147a7.355 7.355 0 119.148 7.085v7.534a7.355 7.355 0 11-3.587 0v-7.534a7.35 7.35 0 01-5.561-7.085zm11.03 0h.001a3.769 3.769 0 00-3.766-3.766 3.768 3.768 0 103.766 3.766zm-7.443 21.704a3.768 3.768 0 107.536 0 3.768 3.768 0 00-7.536 0zM62.4 69.205a7.354 7.354 0 110-14.709 7.354 7.354 0 010 14.709zm0-11.031a3.766 3.766 0 100 7.531 3.766 3.766 0 000-7.532v.001zM18.993 11.09a7.354 7.354 0 017.174 5.919h7.713a7.357 7.357 0 0111.093-4.81 7.355 7.355 0 11-10.914 8.398h-8.07a7.352 7.352 0 01-8.492 5.055 7.356 7.356 0 01-3.455-12.68 7.355 7.355 0 014.95-1.882zM41.055 22.12a3.768 3.768 0 100-7.535 3.768 3.768 0 000 7.535zm-22.062 0a3.766 3.766 0 100-7.532 3.766 3.766 0 000 7.532z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M62.4 47.501l-1.884-.269-13.004 13.094a7.353 7.353 0 11-1.704-3.318l11.57-11.66a7.355 7.355 0 01-2.063-3.407h-7.893a7.356 7.356 0 01-11.319 4.252 7.354 7.354 0 1111.32-7.84h7.892a7.35 7.35 0 018.35-5.458A7.355 7.355 0 0162.398 47.5zM40.337 58.173a3.768 3.768 0 000 7.534 3.767 3.767 0 000-7.534zm0-21.703a3.767 3.767 0 103.767 3.677 3.769 3.769 0 00-3.766-3.767v.09zm22.063 0a3.769 3.769 0 00-3.766 3.797 3.766 3.766 0 107.532-.12 3.768 3.768 0 00-3.767-3.767v.09z"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/topcommercialcleaners/icons/heart.tsx


function Heart() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "80",
        height: "80",
        fill: "none",
        viewBox: "0 0 80 80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_5_116",
                style: {
                    maskType: "alpha"
                },
                width: "80",
                height: "80",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H80V80H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: "#FF8A00",
                mask: "url(#mask0_5_116)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M63.447 41.26c-1.428-7.294-6.767-12.032-13.61-12.032a18.122 18.122 0 00-9.4 2.934 18.047 18.047 0 00-9.476-3.009c-6.768 0-12.258 4.888-13.611 12.108-1.955 9.926 3.986 23.086 21.432 30.08a4.36 4.36 0 003.308 0c17.372-7.144 23.237-20.23 21.357-30.156v.075zm-23.01 24.365c-13.762-5.79-18.575-15.717-17.146-23.161.827-4.512 3.835-7.295 7.67-7.295 2.331 0 5.039 1.053 7.67 3.008a3.01 3.01 0 003.61 0c2.632-1.955 5.264-2.932 7.595-2.932 3.835 0 6.843 2.782 7.67 7.144 1.505 7.444-3.308 17.37-17.07 23.236zM43.444 19.753v-7.745a3.008 3.008 0 00-6.015 0v7.745a3.008 3.008 0 106.015 0zM64.049 13.361a3.007 3.007 0 00-3.986 1.58l-3.309 7.745a3.032 3.032 0 005.566 2.407l3.308-7.746a3.01 3.01 0 00-1.58-3.986h.001zM18.553 25.093a3.017 3.017 0 005.565-2.332l-3.384-7.82a3.017 3.017 0 00-5.565 2.33l3.384 7.822z"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/shared/featureList/index.tsx
var featureList = __webpack_require__(73367);
;// CONCATENATED MODULE: ./src/components/topcommercialcleaners/whyUs/index.tsx






const whyUsList = [
    {
        title: "Save Time & Money",
        description: " Outsourcing your cleaning services can help streamline your expenses and reduce cleaning time by about 25% while ensuring a spotless, disinfected environment.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clock, {})
    },
    {
        title: "Professional Experts, Advanced Technology",
        description: "Our cleaning experts are thoroughly trained and use proprietary cleaning and disinfecting systems that dramatically decrease dust and bacteria, among other compounds.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Circles, {})
    },
    {
        title: "Healthy, Worry-Free Environments",
        description: "Maintaining a clean and healthy environment is vital for a bacteria and virus-free space, whether residential or commercial, to protect you and your visitors or clients from any airborne diseases or infectious diseases.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heart, {})
    }, 
];
function WhyUs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(featureList/* default */.Z, {
        featureList: whyUsList,
        mainTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Custom Cleaning Plans For ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " Clean, Safe & Healthy Environments"
            ]
        }),
        classes: {
            mainTitleClasses: "text-center text-xl lg:text-4xl mx-auto mb-14 ",
            innerSectionClasses: "lg:flex flex-wrap justify-center ",
            oneBoxClasses: "text-center mb-12 lg:mb-20 w-full lg:w-1/3",
            iconClasses: "children:mx-auto",
            titleClasses: "font-medium text-lg mb-5 lg:text-xl mt-6",
            descriptionClasses: "font-light text-sm lg:text-base text-center w-4/5 mx-auto mt-2"
        },
        colors: {
            descriptionColor: "#777777"
        }
    });
}


/***/ }),

/***/ 35533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","item":"styles_item__j6_jF","mainSection":"styles_mainSection__2nFt8","link":"styles_link___4DQd"};

/***/ })

}]);